import { Checkbox } from "antd";
import { useEffect, useRef, useState } from "react";

const AadharVerification = (props) => {
  const [isAccountDisabled, setIsAccountDisabled] = useState(true);
  const isAadharVerified = props.$store?.user?.isAadharVerified;

  const handleAcknowledge = (e) => {
    let value = e.target.checked;
    setIsAccountDisabled(!value);
  };

  // ---------------- AADHAR DIGI-LOCKER FLOW ----------------
  const [aadharData, setAadharData] = useState(null);
  const [hasAadharData, setHasAadharData] = useState(false);
  const digiLockerWindowRef = useRef(null);

  const handleDigilockerLogin = (e) => {
    let callbackUrl =
      window.location.origin + "/open/customer/digilockercallback";

    let payload = {
      callbackUrl,
    };
    props.apis.apiGetDigilockerUrlForUserConsent(payload).then((res) => {
      console.log({ apiGetDigilockerUrlForUserConsent: res });

      if (res?.result) {
        sessionStorage.setItem("aadhaar_request_id", res?.result?.requestId);

        // Open DigiLocker in child tab
        digiLockerWindowRef.current = window.open(
          res?.result?.url,
          "DigiLockerTab",
          "width=1200,height=800"
        );
      }
    });
  };

  const getCustomerInfo = () => {
    props.apis.apiGetCustomerInfo().then((res) => {
      if (res?.aadharCardInfo) {
        let { uid, address, message } = res?.aadharCardInfo;
        if (uid !== null) {
          setHasAadharData(true);
          setAadharData({
            uid,
            address,
          });
        } else {
          setHasAadharData(false);
          swal2.fire({
            title: message || "Failed to get aadhaar data",
            icon: "error",
            iconColor: "#BB1766",
          });
        }
      }
    });
  };

  const fetchAadhaarData = async () => {
    const requestId = sessionStorage.getItem("aadhaar_request_id");
    console.log({ requestId });
    if (!requestId) return;
    let payload = {
      requestId,
    };

    // UPDATE DIGILOCKER API WITH REQUEST ID
    props.apis.apiGetAadharConsentResponseData(payload).then((res) => {
      if (res) {
        console.log("Aadhar response from digi-locker: ", { res });

        props?.store("user.isAadharVerified", true);

        // GET AADHAAR DATA FROM PROFILE API
        props.apis.apiGetCustomerInfo().then((res) => {
          if (res?.aadharCardInfo) {
            let { uid, address, message } = res?.aadharCardInfo;

            if (uid !== null) {
              toast.success("Aadhar Verified Successfully", toastConfig);
              setHasAadharData(true);
              setAadharData({
                uid,
                address,
              });
              props.handleSelect("pan");
            } else {
              setHasAadharData(false);
              props.onClose();
              swal2.fire({
                title: message || "Failed to get aadhaar data",
                icon: "error",
                iconColor: "#BB1766",
              });
            }
          }
        });
      }
    });
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data === "digilocker_complete") {
        fetchAadhaarData();

        // Close child tab if still open
        if (
          digiLockerWindowRef.current &&
          !digiLockerWindowRef.current.closed
        ) {
          digiLockerWindowRef.current.close();
        }
      }
    };

    if (isAadharVerified) {
      // GET AADHAAR DATA FROM PROFILE API
      getCustomerInfo();
    }
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const toastConfig = {
    autoClose: 3000,
    closeButton: false,
    hideProgressBar: true,
  };
  return (
    <>
      {hasAadharData ? (
        <div className="profile_details_container">
          <div className="profile_detail mb-3">
            <p className="m-0">Aadhar no</p>
            <h4>{`XXXX-XXXX-${aadharData?.uid}` || "-"}</h4>
          </div>
          <div className="profile_detail mb-3">
            <p className="m-0">Address as per Aadhar</p>
            <h4>{aadharData?.address || "-"}</h4>
          </div>
          <div className="nav_container">
            <button
              className="formdata-cancel-btn btn"
              onClick={(...args) => props.skipToStep(0)}
            >
              Back
            </button>
            <button
              className="btn btn-primary ms-3"
              onClick={(...args) => props.handleSelect("pan")}
            >
              Next
            </button>
          </div>
        </div>
      ) : (
        <>
          <h4>Instruction to follow:</h4>
          <ul className="aadhar_instruction_ul mb-4">
            <li>
              Click on the below <span>Login to Digilocker</span> button.{" "}
            </li>
            <li>
              It will take you a new tab to enter your 12 digit Aadhar card
              number.
            </li>
            <li>
              Click <span>Next</span> and provide the OTP from the Aadhar card
              owner's phone.
            </li>
            <li>
              After clicking <span>Continue</span> button, accept{" "}
              <span>Signzy</span> access to <span>DigiLocker</span> by clicking
              on Allow button.
            </li>
          </ul>
          <Checkbox onChange={handleAcknowledge}>
            I hereby understand the above instructions and wiling to use this
            service.
          </Checkbox>

          <div className="d-flex mt-5 justify-content-end">
            <button
              className="formdata-cancel-btn btn"
              onClick={(...args) => props.skipToStep(0)}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary ms-3"
              onClick={(...args) => handleDigilockerLogin(...args)}
              disabled={isAccountDisabled}
            >
              Login to Digilocker
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default constore(AadharVerification);
